import { ApolloError } from '@apollo/client';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { TemplateType } from 'constants/templateTypes';
import { SelectedMessageMedium, UnselectedMessageMedium } from '../common/types';
import { UseTemplateEditSingleContentById } from '../hooks/useTemplateSingleContentEditById';

export interface TemplateQueryContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  isAssociatedWithActiveExperiment: boolean;
  medium: SelectedMessageMedium;
  messageTypeId: number;
  templateType?: TemplateType;
  previousDataLocale?: string;
  previousDataTemplateId?: number;
  refetch: () => void;
  refetchTemplateAsync: () => Promise<UseTemplateEditSingleContentById>;
  template: string;
}

export const TemplateQueryContext = createContext<TemplateQueryContextState>({
  errorMessage: '',
  hasError: false,
  isLoading: true,
  isAssociatedWithActiveExperiment: false,
  medium: UnselectedMessageMedium.Unselected,
  messageTypeId: -1,
  templateType: undefined,
  previousDataLocale: undefined,
  previousDataTemplateId: undefined,
  refetch: noop,
  refetchTemplateAsync: async () => ({}) as any,
  template: '{}',
});

export const useTemplateQueryContext = () => useContext(TemplateQueryContext);
